
import { io } from 'socket.io-client';
import { store } from '../state/store';
import { url } from '../services/api';
import { clearNotifications } from '../state/notification/actions';

class SocketClient {
    socket;

    connect(token) {
        this.socket = io.connect(url,
            { transports: ['websocket'], auth: { token } });

    }
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            store.dispatch(clearNotifications())

        }
    }
    on(event, callback) {
        if (this.socket) {
            this.socket.on(event, callback);
        }
    }
    emit(event, data) {

    }
}

const socketClient = new SocketClient();

export default socketClient;